import { Col, Row, Form } from "react-bootstrap";
import { Autocomplete, TextField } from "@mui/material";
import { autocompleteDropdownStyles } from "Constants/Style";
interface Props {
  formik: any;
  setItems: React.Dispatch<React.SetStateAction<any[]>>;
  currencyList: { label: string; value: string; currency_id?: string; currency_name?: string; currency_symbol?: string }[];
  onExchangeChange?: (value: number | string) => void; // callback to update table
}

const CurrencyExchangeSection = ({
  formik,
  setItems,
  currencyList,
  onExchangeChange,
}: Props) => {
  return (
    <Row>
      {/* ================= CURRENCY CODE ================= */}
      <Col md={6}>
        <Form.Group className="mb-3">
          <Form.Label>Currency Code</Form.Label>

          <Autocomplete
            size="small"
            options={currencyList}
            value={
              currencyList.find(
                (item) => item.value === formik.values.currency_code
              ) || null
            }
            
            onChange={(e, selected) => {
              if (!selected) {
                formik.setFieldValue("currency_code", "INR");
                formik.setFieldValue("currency_symbol", "₹");
                formik.setFieldValue("composition_gst", false);
                formik.setFieldValue("select_composition_gst", "");
                formik.setFieldTouched("currency_code", true);
                formik.setFieldValue("exchange_rate", "1");

                setItems((prev) =>
                  prev.map((item) => ({
                    ...item,
                    currency_code: "INR",
                    currency_symbol: "₹",
                    exchange_rate: "1",
                  }))
                );

                onExchangeChange?.("");
                return;
              }
              formik.setFieldValue("currency_code", selected?.value || "");
              formik.setFieldValue("currency_symbol", selected?.currency_symbol || "");
              formik.setFieldTouched("currency_code", true);
              setItems((prev) =>
                prev.map((item) => ({
                  ...item,
                  currency_code: selected?.value,
                  currency_symbol: selected?.currency_symbol || "",
                }))
              );
              // If currency changes → reset exchange value
              if (selected?.value === "INR" || selected?.value === "IND") {
                formik.setFieldValue("exchange_rate", "1");
                setItems((prev) =>
                  prev.map((item) => ({ ...item, exchange_rate: "1" }))
                );
                onExchangeChange?.("");
              }
            }}
            getOptionLabel={(option) => option.label}
            ListboxProps={autocompleteDropdownStyles.ListboxProps}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select"
                size="small"
                error={
                  formik.touched.currency_code &&
                  Boolean(formik.errors.currency_code)
                }
                helperText={
                  formik.touched.currency_code && formik.errors.currency_code
                }
                sx={autocompleteDropdownStyles.inputSx}
              />
            )}
          />
        </Form.Group>
      </Col>

      {/* ================= EXCHANGE RATE ================= */}
      <Col md={6}>
        <Form.Group className="mb-3">
          <Form.Label>
            Exchange Rate (in INR){" "}
            {formik.values.currency_code !== "IND" && formik.values.currency_code !== "INR" && (
              <span className="text-danger">*</span>
            )}
          </Form.Label>

          <Form.Control
            type="number"
            name="exchange_rate"
            value={formik.values.exchange_rate}
            onWheel={(e) => e.preventDefault()}
            onChange={(e) => {
              formik.setFieldValue("exchange_rate", e.target.value);

              setItems((prev) =>
                prev.map((item) => ({ ...item, exchange_rate: e.target.value }))
              );
              // send rate back to parent so table can update
              onExchangeChange?.(e.target.value);
            }}
            onBlur={formik.handleBlur}
            disabled={formik.values.currency_code === "IND" || formik.values.currency_code === "INR"}
            placeholder={
              formik.values.currency_code === "IND" || formik.values.currency_code === "INR"
                ? "Not required"
                : "Enter rate"
            }
            isInvalid={
              formik.touched.exchange_rate && !!formik.errors.exchange_rate
            }
          />
          <Form.Control.Feedback type="invalid">
            {formik.errors.exchange_rate}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>
    </Row>
  );
};

export default CurrencyExchangeSection;
